export class CompanyDistrictMapUpdateDto {
  lat?: string;
  lon?: string;
  region1DepthName?: string;
  region2DepthName?: string;
  region3DepthName?: string;
  hCode?: string;
  bCode?: string;
}
